var _circle, _circle2, _circle3, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgCompleteMaintainStation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77,
    cy: 75.5,
    r: 70,
    stroke: "#89F3B8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77,
    cy: 75.5,
    r: 75,
    stroke: "#89F3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 75.5,
    r: 63.5,
    stroke: "#89F3B8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 75.5C17.5 42.6391 44.1391 16 77 16C109.861 16 136.5 42.6391 136.5 75.5C136.5 108.361 109.861 135 77 135C44.1391 135 17.5 108.361 17.5 75.5Z",
    fill: "url(#paint0_linear_16929_328680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.375 54H100V59.625V100.875V106.5H94.375H60.625H55V100.875V59.625V54H60.625H64.375H68.2422C69.1797 49.7812 72.9297 46.5 77.5 46.5C81.9531 46.5 85.8203 49.7812 86.6406 54H90.625H94.375ZM64.375 59.625H60.625V100.875H94.375V59.625H90.625V65.25H77.5H64.375V59.625ZM74.6875 55.875C74.6875 57.5156 75.8594 58.6875 77.5 58.6875C79.0234 58.6875 80.3125 57.5156 80.3125 55.875C80.3125 54.3516 79.0234 53.0625 77.5 53.0625C75.8594 53.0625 74.6875 54.3516 74.6875 55.875ZM88.8672 77.9062L76.3281 90.4453L74.3359 92.4375L72.3438 90.4453L66.1328 84.1172L64.1406 82.125L68.125 78.1406L70.1172 80.1328L74.3359 84.4688L84.8828 73.9219L86.875 71.9297L90.8594 75.9141L88.8672 77.9062Z",
    fill: "url(#paint1_linear_16929_328680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16929_328680",
    x1: 77,
    y1: 16,
    x2: 77,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16929_328680",
    x1: 77.5,
    y1: 35,
    x2: 77.5,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCompleteMaintainStation);
export default __webpack_public_path__ + "static/media/img_complete_maintain_station.365b09e7e55a8bf2edb6f26d47be29b2.svg";
export { ForwardRef as ReactComponent };